import { createContext } from "react"

export const ActiveFilterContext = createContext<string>("Keywords")
